import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/Authcontext";
import Team from "../assets/Team.svg";

import g from "../assets/g.svg";
import m from "../assets/m.svg";
import d from "../assets/d.svg";

import star from "../assets/star.svg";
import avatar from "../assets/realavatar.png";
import code from "../assets/code.png";
const Listformation = () => {
  const navigate = useNavigate();
  const { contextData } = useContext(AuthContext);
  const [formations, setformations] = useState([]);
  const [topics, settopics] = useState([]);
  const [formationsfiltered, setformationsfiltered] = useState([]);
  const [didsearch, setdidsearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    gettopics();
    getformations();
  }, []);

  const gettopics = async () => {
    const { data } = await axios.get(
      "https://pfebackend-zbz0.onrender.com/api/topics/"
    );
    settopics(data);
  };

  const getFiles = async (ids) => {
    const responses = await Promise.all(
      ids.map(async (id) => {
        const response = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/formations/image/${id}/`,
          {
            responseType: "blob",
          }
        );
        return response.data;
      })
    );

    const blobs = responses.map((response) => new Blob([response]));
    let urls = blobs.map((blob) => window.URL.createObjectURL(blob));

    for (let i = 0; i < urls.length; i++) {
      // const image = document.getElementById(`image-${i}`);
      const image = document.getElementsByClassName(`${ids[i]}`);
      for (let j = 0; j < image.length; j++) {
        image[j].src = urls[i];
      }
      // image.src = urls[i];
    }
  };

  const getformations = async () => {
    let list = [];
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/formations/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setformations(responce.data);
    // responce.data.map((e) => list.push(e.id));
    // getFiles(list);
  };

  const handelshoseformation = async (e) => {
    if (contextData.user) {
      const { data } = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/user/formation/${e.id}/`,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
      data
        ? navigate(`formation/${e.id}/`)
        : navigate(`formation/description/${e.id}/`);
    } else {
      navigate(`formation/description/${e.id}/`);
    }
  };

  const handelsearchformation = async (e) => {
    e.preventDefault();
    const search = e.target[0].value;
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/formations/filter/${search}/`
    );

    setformationsfiltered(data);

    setdidsearch(true);
  };
  const handeldeletesearch = () => {
    setformationsfiltered([]);
    setdidsearch(false);
    setSearchValue("");
  };

  const gotoalltrainings = () => {
    navigate("/formations");
  };
  const gotoCategory = (name) => {
    navigate(`/formations/categorie/${name}`);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  }, []);

  return (
    <div className="home-container">
      <div className="homepageheader">
        <div className="homepageheader-text">
          <h3 className="homepageheader-text-header">
            WELCOME TO <span className="ecoin">ECOIN</span> LEARNING PLATFORM
          </h3>
          <p className="homepageheader-text-text">
            Are you looking to expand your knowledge and skills in aconvenient
            and accessible way? Look no further than our e-learning platform! We
            offer a wide range of courses on various topics from business and
            technology to creative arts and personal development.
          </p>
        </div>

        <img className="homepageheader-image" src={Team} alt="" />
      </div>

      <div className="homepagenumbers">
        <span className="homepagenumbers-n">
          <img className="gmd-image" src={g} alt="" />
          <span>
            <p className="homepagenumbers-number"> +10K</p>

            <p className="homepagenumbers-text">TOTAL COURSES</p>
          </span>
        </span>

        <span className="homepagenumbers-n">
          <img className="gmd-image" src={m} alt="" />
          <span>
            <p className="homepagenumbers-number"> +200</p>

            <p className="homepagenumbers-text">EXPERT MENTORS</p>
          </span>
        </span>

        <span className="homepagenumbers-n">
          <img className="gmd-image" src={d} alt="" />
          <span>
            <p className="homepagenumbers-number"> +50K</p>

            <p className="homepagenumbers-text">STUDENTS</p>
          </span>
        </span>
      </div>

      <div className="home-header">
        <h1>Popular courses</h1>

        <div className="displaynone searchcontainer farum-search hidethis">
          <form onSubmit={handelsearchformation}>
            <input
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              type="text"
              placeholder="search for training"
            />
          </form>
          <button onClick={handeldeletesearch} className="btn">
            X
          </button>
        </div>
      </div>

      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}

      {/* this part is for the filterded things */}

      <div className="courses-container">
        {formationsfiltered.map((e, i) => {
          return (
            <article
              onClick={() => handelshoseformation(e)}
              key={i}
              className="card"
            >
              {true === true ? (
                <img
                  className={`card-image  ${e.id}`}
                  src={e.image}
                  id={`image-${i}`}
                  alt=""
                />
              ) : (
                <p>Loading image...</p>
              )}
              <div className="card-text-container">
                <h5 className="card-title">{e.name}</h5>
                <p className="card-discrition">
                  {e.description.substring(0, 70) + "..."}
                </p>
                <div className="rating-container">
                  <img className="star" src={star} alt="" />
                  <p className="rating">{e.rating}</p>
                </div>
                <p className="price">{e.price} Da</p>
              </div>
            </article>
          );
        })}
      </div>

      {didsearch && formationsfiltered.length === 0 && (
        <div className="alert alert-danger" role="alert">
          no formation found
        </div>
      )}

      {/* end of the filterded things */}

      <div className="courses-container">
        {formations.map((e, i) => {
          return (
            <article
              onClick={() => handelshoseformation(e)}
              key={i}
              className="card"
            >
              {true === true ? (
                <img
                  className={`card-image  ${e.id}`}
                  src={e.image}
                  id={`image-${i}`}
                  alt=""
                />
              ) : (
                <p>Loading image...</p>
              )}
              <div className="card-text-container">
                <h5 className="card-title">{e.name}</h5>
                <p className="card-discrition">
                  {e.description.substring(0, 70) + "..."}
                </p>
                <div className="rating-container">
                  <img className="star" src={star} alt="" />
                  <p className="rating">{e.rating}</p>
                </div>
                <p className="price">{e.price} Da</p>
              </div>
            </article>
          );
        })}
      </div>
      <div className="buttoncheckall">
        <button onClick={gotoalltrainings} className="checkall">
          CHECK ALL
        </button>
      </div>

      <h2 style={{ margin: "0 1rem" }}>Explore by category</h2>

      <div className="category-container">
        {topics.map((e, index) => {
          return (
            <div
              onClick={() => gotoCategory(e.name)}
              key={index}
              className="category"
            >
              {" "}
              {e.name}
            </div>
          );
        })}
      </div>

      <div className="studentsays">
        <div className="studentsays-text">
          <h3 className="studentsays-text-title">
            What our students are saying about us
          </h3>
          <p className="studentsays-text-text">
            {" "}
            Join our community of lifelong learners today and unlock your full
            potential!"
          </p>
        </div>
        <div className="studentsays-profile">
          <div className="studentsays-profile-header">
            <div className="studentsays-profile-header-photoname">
              <img
                className="studentsays-profile-header-photo"
                src={avatar}
                alt=""
              />
              <p className="studentsays-profile-header-name">latif meriem.</p>
            </div>

            <img className="studentsays-header-image" src={code} alt="" />
          </div>
          <h4 className="studentsays-profile-title">
            It's the perfect way to learn new skills and expand your knowledge!
          </h4>
          <p className="studentsays-profile-text">
            "I loved this e-learning platform! The courses were engaging and
            easy to follow, and I earned a certificate of completion."
          </p>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-col">
          <h3 className="footer-stitle">E-COIN</h3>
          <ul className="footer-list">
            <li className="footer-item">
              Learn anytime, anywhere with our e-learning platform. Choose from
              a variety of engaging courses taught by expert instructors. Start
              your learning journey today!{" "}
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-stitle">EXPLORE</h3>
          <ul className="footer-list">
            <li className="footer-item">About us</li>
            <li className="footer-item">Contact us</li>
            <li className="footer-item">Services</li>
          </ul>
        </div>
        <div className="footer-col">
          <h3 className="footer-stitle">LEGAL</h3>
          <ul className="footer-list">
            <li className="footer-item">Terms & conditions</li>
            <li className="footer-item">Privacy Policy</li>
          </ul>
        </div>
        <div className="footer-col">
          <h3 className="footer-stitle">Contact</h3>
          <ul className="footer-list">
            <li className="footer-item">0758453256</li>
            <li className="footer-item">0578462231</li>
            <li className="footer-item">
              123 Fifth Floor East 26th Street, Alger, 10011 ecoin@gmail.com
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default Listformation;
